export const TOKEN_KEY: string = "1A2C8E48FFDDC5E9F7E76907885C8C68";
export const BASE_API_ORIGIN: string = "";
export const BASE_API_PATH: string = "/api";

export const TAPTALK: {
    APP_ID: string,
    APP_SECRET: string;
    APP_BASE_URL: string;
} = { APP_ID: "", APP_SECRET: "", APP_BASE_URL: "" };